import { useEffect, useState } from "react";

import usePostHook from "../../customHooks/usePostHook";

import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

import { useDebounce } from "../../customHooks/useDebounceHook";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import Spinner from "../reusable/Spinner";
import Card from "../reusable/Card";
const RemoteChargeTable = (props: any) => {
  const { localServiceBranch } = props;

  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debounceSearch = useDebounce(searchQuery);
  const { data: RemoteAreaChargeData, isLoading: remoteAreaChargeLoading } =
    useGetHook({
      queryKey: [
        "remote-charge",
        `remote-charge-${localServiceBranch}-${debounceSearch}`,
      ],
      url: APIS.REMOTE_CHARGE,
      params: {
        origin: localServiceBranch,
        search: debounceSearch,
      },
    });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [
      "remote-charge",
      `remote-charge-${localServiceBranch}-${debounceSearch}`,
    ],
    navigateURL: ``,
  });

  const handleDeliveryChargeChange = async (
    destination: string,
    zip_code: string,
    amount: string
  ) => {
    const url = `${APIS.REMOTE_CHARGE}`;
    let formData = {
      origin: localServiceBranch,
      destination: destination,
      zip_code: zip_code,
      amount: amount,
    };

    try {
      const res = await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const [rerender, setRerender] = useState(true);

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  useEffect(() => {
    setRerender(!rerender);
  }, [RemoteAreaChargeData]);

  return (
    <div className={tw`w-full overflow-auto min-h-10`}>
      <div className={tw`w-52`}>
        <input
          type="text"
          placeholder="Search"
          value={searchQuery ?? ""}
          onChange={(e) => handleSearch(e?.target?.value)}
          className={tw`border w-full border-1 border-primary focus:outline-none p-1`}
        />
      </div>
      {remoteAreaChargeLoading ? (
        <Spinner />
      ) : (
        <div className={tw`w-full overflow-x-auto`}>
          <table className={tw`w-full`}>
            <thead className={tw`text-justify`}>
              <tr>
                <th className={tw`pr-12 whitespace-nowrap`}>
                  Destination Country
                </th>
                <th className={tw`pr-12 whitespace-nowrap`}> Postal Code</th>
                <th className={tw`pr-12 whitespace-nowrap`}> Remote Charge</th>
              </tr>
            </thead>
            <tbody>
              {RemoteAreaChargeData?.map((productType: any, index: number) => (
                <tr
                  key={productType?.id}
                  className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 border`}
                >
                  <td
                    key={`detination-${productType?.id}`}
                    className={tw`py-2`}
                  >
                    {productType?.destination?.name}
                  </td>
                  <td
                    key={`zip-code-${productType?.id}`}
                    className={tw`px-8 uppercase py-2 text-sm`}
                  >
                    {productType?.zip_code ?? "N/A"}
                  </td>

                  <td key={`rate-${productType?.id}`}>
                    <input
                      type="text"
                      className={tw`bg-transparent py-2`}
                      onBlur={(event: any) =>
                        handleDeliveryChargeChange(
                          RemoteAreaChargeData?.[index]?.destination?.id,
                          remoteAreaChargeLoading?.[index]?.zip_code,
                          event?.target?.value
                        )
                      }
                      defaultValue={productType?.amount}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RemoteChargeTable;
